import { render } from "./ProfileDescriptionlEdit.vue?vue&type=template&id=f49e8412&lang=pug"
import script from "./ProfileDescriptionlEdit.vue?vue&type=script&lang=js"
export * from "./ProfileDescriptionlEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__